import { InputText } from 'macaron-frontend-ui'
import { useCallback } from 'react'
import { useAffiliateSiteFormAnswer } from '~/features/reservationInput/store/stateMachine/context'
import { css } from '~/styled-system/css'
import { useReserveInfo } from '../../store/stateMachine/state'
import {
  useAffiliateSiteFormAnswerError,
  useSetAffiliateSiteFormAnswer,
} from '../../store/userInput'
import { Section } from '../Section'

export function AffiliateSiteForm() {
  const { affiliateSiteForm, value, error, onChange } = useAffiliateSiteForm()
  if (affiliateSiteForm === null || affiliateSiteForm === undefined) {
    return null
  }
  return (
    <Section title={affiliateSiteForm.title} sectionClass={css({ spaceY: '3' })}>
      <InputText
        placeholder={affiliateSiteForm.title}
        withSpread={true}
        maxLength={50}
        onChange={onChange}
        value={value}
        errorMessage={error}
      />
      <p className="whitespace-pre-wrap break-words text-sm">{affiliateSiteForm.notes}</p>
    </Section>
  )
}

function useAffiliateSiteForm() {
  const affiliateSiteForm = useReserveInfo()?.affiliateSiteForm
  const value = useAffiliateSiteFormAnswer()
  const change = useSetAffiliateSiteFormAnswer()
  const error = useAffiliateSiteFormAnswerError()
  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      change(e.target.value)
    },
    [change]
  )
  return { affiliateSiteForm, value, error, onChange }
}
